module.exports = __webpack_public_path__ + "img/driver.9fbb2b06.svg";